 require('./audio.css');
 var template = require('./audio.ejs');

 function formatSoundWidth(time){
    var width;
      if (time <= 2) {
          width = 20;
      } else if (time <= 10) {
          width = 20 + (time - 2) * 5;
      } else {
          width = 60 + Math.floor((time - 10) / 10) * 5;
      }
      if (width >= 100) {
          width = 80;
      }
      return width;
    }

function formatAudioUrl (url) {
	var houzhui = url.substring(url.lastIndexOf('.') + 1);
        return url.replace('.' + houzhui, '.mp3');

}

 // 播放时长格式化
 var timeFormat = function (duration) {
     var seconds = duration % 60 || '00';
     var minutes = parseInt(duration / 60);
     minutes = minutes > 0 ? minutes + "'" : '';
     return minutes + seconds + '"';
 };

    module.exports = function (audioData) {
    	audioData.width = formatSoundWidth(audioData.audio_duration);
    	audioData.audio_url = formatAudioUrl(audioData.audio_url);
        audioData.audio_duration = timeFormat(audioData.audio_duration);
    	return template(audioData);
    };


// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.component.audio.mobile/app/modules/audio/index.js